import { render, staticRenderFns } from "./ListaUsuarios.vue?vue&type=template&id=36bb62f0&scoped=true"
import script from "./ListaUsuarios.vue?vue&type=script&lang=js"
export * from "./ListaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./ListaUsuarios.vue?vue&type=style&index=0&id=36bb62f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb62f0",
  null
  
)

export default component.exports